import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, TableSortLabel } from '@material-ui/core';

const EnhancedTableHead = ({ order, orderBy, onRequestSort, heads }) => {
  const createSortHandler = (property) => (event) => onRequestSort(event, property);

  return (
    <TableHead style={{ background: '#4f4747' }}>
      <TableRow>
        {heads.map((head, index) => (
          <TableCell
            key={`${index}-${head.key}`}
            style={{
              fontWeight: 'bold',
              fontSize: '10px',
              textTransform: 'uppercase',
              color: 'white',
              padding: '6px 2px',
              opacity:
                head?.hasDiagnosticsModule === true ? 1 : head?.hasDiagnosticsModule === false ? 0.3 : 1,
            }}
            align={head.align}
            padding='normal'
            sortDirection={orderBy === head.key ? order.toLowerCase() : false}>
            <TableSortLabel
              active={orderBy === head.key}
              direction={orderBy === head.key ? order.toLowerCase() : 'asc'}
              onClick={createSortHandler(head.key)}>
              {head.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  order: PropTypes.oneOf(['ASC', 'DESC']).isRequired,
  orderBy: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  heads: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.string,
    })
  ).isRequired,
};

export default EnhancedTableHead;
